import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class JwtHelperService {
  constructor() {}

  /**
   * Decodes a JWT token and returns the payload
   * @param token JWT token string
   * @returns Decoded token payload or null if invalid
   */
  decodeToken(token: string): any {
    if (!token) {
      return null;
    }

    try {
      const parts = token.split('.');
      if (parts.length !== 3) {
        return null;
      }

      // Get the payload (second part)
      const payload = parts[1];
      const base64 = payload.replace(/-/g, '+').replace(/_/g, '/');
      const jsonPayload = decodeURIComponent(
        atob(base64)
          .split('')
          .map(c => '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2))
          .join('')
      );

      return JSON.parse(jsonPayload);
    } catch (error) {
      console.error('Error decoding token:', error);
      return null;
    }
  }

  /**
   * Checks if a token is expired
   * @param token JWT token string
   * @param offsetSeconds Optional buffer time in seconds (default: 60)
   * @returns True if token is expired or about to expire, false otherwise
   */
  isTokenExpired(token: string, offsetSeconds: number = 10): boolean {
    if (!token) {
      return true;
    }

    const decoded = this.decodeToken(token);
    if (!decoded || !decoded.exp) {
      return true;
    }

    const date = new Date(0);
    // Convert exp to milliseconds and subtract offset
    date.setUTCSeconds(decoded.exp - offsetSeconds);

    return date.valueOf() <= new Date().valueOf();
  }

  /**
   * Gets the expiration timestamp from a token
   * @param token JWT token string
   * @returns Expiration timestamp in milliseconds, or null if invalid
   */
  getTokenExpirationDate(token: string): number | null {
    const decoded = this.decodeToken(token);
    if (!decoded || !decoded.exp) {
      return null;
    }

    return decoded.exp * 1000; // Convert to milliseconds
  }
}
